export default function genererCritereRecherche() {
  return {
    auto: null,
    statut: [],
    code: null,
    produitsIds: [],
    parutionsIds: [],
    tiersId: [],
    commercialId: null,
  };
}

export function genererCritereRechercheCommandes() {
  return {
    auto: '',
    client: '',
    codeDossier: '',
    referenceClient: '',
    etat: [],
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    agencesId: [],
    tiersId: [],
    categorieVente: [],
    commercialId: [],
    assistantIds: [],
    referenceIds: [],
    ids: [],
    themes: [],
    clients: [],
    estSigne: null,
    interne: null,
    produitsIds: [],
  };
}
